export interface IIncludedShops {
  month: number
  shopIds: string[]
  shopsCount: number
}
